import { AccordionMenu } from "./accordion-menu.js";
import { styles } from "./accordion-menu.styles.js";
import { template } from "./accordion-menu.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-accordion-menu>
 */
export const definition = AccordionMenu.compose({
    name: `${DesignSystem.prefix}-accordion-menu`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=accordion-menu.definition.js.map